import { CBINSIGHTS_AVATAR, PITCHBOOK_AVATAR, STATISTA_AVATAR, WILEY_AVATAR, WILEY_FORMATTED_NAME, } from '#pplx/frontend/branded-sources/consts.js';
import { ASANA_AVATAR, ASANA_FORMATTED_NAME, ATLASSIAN_AVATAR, ATLASSIAN_FORMATTED_NAME, BOX_AVATAR, BOX_FORMATTED_NAME, CONFLUENCE_AVATAR, CONFLUENCE_FORMATTED_NAME, CRUNCHBASE_AVATAR, DROPBOX_AVATAR, DROPBOX_FORMATTED_NAME, FACTSET_AVATAR, FACTSET_FORMATTED_NAME, FINANCE_AVATAR, GITHUB_AVATAR, GITHUB_FORMATTED_NAME, GMAIL_AVATAR, GOOGLE_CALENDAR_AVATAR, GOOGLE_CALENDAR_FORMATTED_NAME, GOOGLE_DRIVE_AVATAR, GOOGLE_DRIVE_FORMATTED_NAME, JIRA_AVATAR, JIRA_FORMATTED_NAME, LINEAR_AVATAR, LINEAR_FORMATTED_NAME, MICROSOFT_TEAMS_AVATAR, MICROSOFT_TEAMS_FORMATTED_NAME, NOTION_AVATAR, NOTION_FORMATTED_NAME, ONEDRIVE_AVATAR, ONEDRIVE_FORMATTED_NAME, OUTLOOK_AVATAR, OUTLOOK_FORMATTED_NAME, SHAREPOINT_AVATAR, SHAREPOINT_FORMATTED_NAME, SLACK_AVATAR, SLACK_DIRECT_FORMATTED_NAME, SLACK_FORMATTED_NAME, ZOOM_AVATAR, ZOOM_FORMATTED_NAME, PLAID_FORMATTED_NAME, } from '#pplx/frontend/components/utils/consts.js';
export const connectorTypeToName = (connector) => {
    switch (connector) {
        case 'GOOGLE_DRIVE':
            return GOOGLE_DRIVE_FORMATTED_NAME;
        case 'ONEDRIVE':
            return ONEDRIVE_FORMATTED_NAME;
        case 'SHAREPOINT':
            return SHAREPOINT_FORMATTED_NAME;
        case 'DROPBOX':
            return DROPBOX_FORMATTED_NAME;
        case 'BOX':
            return BOX_FORMATTED_NAME;
        case 'WILEY':
            return WILEY_FORMATTED_NAME;
        case 'GCAL':
            return GOOGLE_CALENDAR_FORMATTED_NAME;
        case 'NOTION_MCP':
            return NOTION_FORMATTED_NAME;
        case 'LINEAR':
        case 'LINEAR_ALT':
            return LINEAR_FORMATTED_NAME;
        case 'SLACK':
            return SLACK_FORMATTED_NAME;
        case 'SLACK_DIRECT':
            return SLACK_DIRECT_FORMATTED_NAME;
        case 'GITHUB_MCP_DIRECT':
            return GITHUB_FORMATTED_NAME;
        case 'ASANA_MCP_DIRECT':
            return ASANA_FORMATTED_NAME;
        case 'ASANA_MCP_MERGE':
            return ASANA_FORMATTED_NAME;
        case 'ATLASSIAN_MCP_DIRECT':
            return ATLASSIAN_FORMATTED_NAME;
        case 'JIRA_MCP_MERGE':
            return JIRA_FORMATTED_NAME;
        case 'CONFLUENCE_MCP_MERGE':
            return CONFLUENCE_FORMATTED_NAME;
        case 'MICROSOFT_TEAMS_MCP_MERGE':
            return MICROSOFT_TEAMS_FORMATTED_NAME;
        case 'OUTLOOK':
            return OUTLOOK_FORMATTED_NAME;
        case 'FACTSET':
            return FACTSET_FORMATTED_NAME;
        case 'ZOOM':
            return ZOOM_FORMATTED_NAME;
        case 'PLAID':
            return PLAID_FORMATTED_NAME;
        default:
            return '';
    }
};
export const getConnectorAvatar = (connectorName) => {
    switch (connectorName) {
        case 'crunchbase':
            return CRUNCHBASE_AVATAR;
        case 'factset':
            return FACTSET_AVATAR;
        case 'wiley':
            return WILEY_AVATAR;
        case 'google_drive':
            return GOOGLE_DRIVE_AVATAR;
        case 'onedrive':
            return ONEDRIVE_AVATAR;
        case 'sharepoint':
            return SHAREPOINT_AVATAR;
        case 'gcal':
            return GOOGLE_CALENDAR_AVATAR;
        case 'dropbox':
            return DROPBOX_AVATAR;
        case 'box':
            return BOX_AVATAR;
        // @ts-expect-error - FIXME: Missing from BE API
        case 'gmail':
            return GMAIL_AVATAR;
        case 'notion_mcp':
            return NOTION_AVATAR;
        case 'outlook':
            return OUTLOOK_AVATAR;
        // @ts-expect-error - FIXME: Missing from BE API
        case 'linear_native':
        case 'linear':
        case 'linear_alt':
            return LINEAR_AVATAR;
        case 'slack':
        case 'slack_direct':
            return SLACK_AVATAR;
        case 'github_mcp_direct':
            return GITHUB_AVATAR;
        case 'asana_mcp_direct':
        case 'asana_mcp_merge':
            return ASANA_AVATAR;
        case 'atlassian_mcp_direct':
            return ATLASSIAN_AVATAR;
        case 'jira_mcp_merge':
            return JIRA_AVATAR;
        case 'confluence_mcp_merge':
            return CONFLUENCE_AVATAR;
        case 'microsoft_teams_mcp_merge':
            return MICROSOFT_TEAMS_AVATAR;
        case 'wiley_mcp_cashmere':
            return WILEY_AVATAR;
        case 'cbinsights_mcp_cashmere':
            return CBINSIGHTS_AVATAR;
        case 'pitchbook_mcp_cashmere':
            return PITCHBOOK_AVATAR;
        case 'statista_mcp_cashmere':
            return STATISTA_AVATAR;
        case 'zoom':
            return ZOOM_AVATAR;
        // @ts-expect-error - FIXME: Missing from BE API
        case 'finance':
        case 'plaid':
            return FINANCE_AVATAR;
        default:
            return null;
    }
};
//# sourceMappingURL=connectors.js.map